import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { getHomePaymentsInfolist } from "../../../api/BorrowerApi";
import { getMockHomePaymentsInfolist } from "../../../api/mock/MockBorrowerApi";
import { convertToDollar, formatDataProperties } from "../../../Helpers";
import { IProxyUser } from "../../interfaces/Global";
import BCEmptyState from "../../ui/BCEmptyState";
import BCTable from "../../ui/BCTable";
import "../../../styles/borrower/home.scss";
import { IHomePaymentsView } from "../../interfaces/Borrower";
import { FeatureFlags } from "../../constants/LocalServerConstants";

interface IBWPaymentsContent {
  isApiMessage: string[];
  setIsApiMessage: React.Dispatch<React.SetStateAction<string[]>>;
  proxyUser: IProxyUser | undefined;
  activeOnlyPayments: boolean;
}

const BWPaymentsContent = ({ 
  isApiMessage,
  setIsApiMessage,
  proxyUser,
  activeOnlyPayments
} : IBWPaymentsContent) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [paymentsInfoData, setPaymentsInfoData] = useState(undefined as any);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const convertToTableFormat = (payments) => {
    const sortedPayments = payments.slice(0, 30).sort((a, b) => new Date(b.transactionEffectiveDate).getTime() - new Date(a.transactionEffectiveDate).getTime());
    const sortedActivePayments = sortedPayments.filter(payment => payment.isActive === true).slice(0, 6);
    const result = [] as IHomePaymentsView[];
    const formatDataValue = (data) => {
      data.forEach(payment => result.push({
        "loanNumber": payment.loanNumber,
        "project": payment.projectName, //TODO: find out how to get project name
        "date": new Date(payment.transactionEffectiveDate).toLocaleDateString(),
        "amount": convertToDollar(payment.transactionAmount),
      }));
    };

    if (activeOnlyPayments) {
      formatDataValue(sortedActivePayments);
    }
    else {
      formatDataValue(sortedPayments.slice(0, 6));
    }

    return formatDataProperties(result, [{field: "loanNumber", action: "rename", name: "Loan #"}]);
  };

  useEffect(() => {
    const getPaymentsInfoAsync = async () => {
      try {
        // TODO: endpoints not working - Task 4475
        const response = FeatureFlags.IS_MOCK ? await getMockHomePaymentsInfolist() : await getHomePaymentsInfolist(proxyUser && proxyUser.id);
        if (response && response.ok) {
          const paymentsInfo = await response.json();
          setPaymentsInfoData(paymentsInfo);
        }
        else {
          FeatureFlags.IS_DEBUG && console.log("Payments response:");
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage([...isApiMessage, "Payments"]);
        }
      }
      catch (error) {
        handleError();
      }
      
      setIsLoading(false);
    };

    getPaymentsInfoAsync();
  }, [handleError, proxyUser]);
    
  return (
    <React.Fragment>
      {isLoading ? <div className="borrower-home-loader"><Loader active inline="centered" size="big" /></div> : 
        <React.Fragment>
          {paymentsInfoData && convertToTableFormat(paymentsInfoData).length > 0 ? <BCTable 
              data={convertToTableFormat(paymentsInfoData)}
              selectable
              overflowX
              dataSingleLine
              sortable={["Loan #", "Project", "Date", "Amount"]}
              pagination={15}
            /> 
          : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon="dollar sign"
              text="You currently do not have any payment history"
            />
          }
        </React.Fragment>
      }
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(paymentsInfoData)}>paymentsInfoData</button>
        <button onClick={() => console.log(activeOnlyPayments)}>activeOnlyPayments</button>
      </React.Fragment>}
    </React.Fragment>
  );
};

export default BWPaymentsContent;